import React from 'react';
import { HeroVariant11 } from '../components/HeroVariant11';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage11() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1453">
      <Navigation data-id="element-1454" />
      <main data-id="element-1455">
        <HeroVariant11 data-id="element-1456" />
        <WhyUs data-id="element-1457" />
        <Services data-id="element-1458" />
        <FAQ data-id="element-1459" />
        <Testimonials data-id="element-1460" />
        <Consultation data-id="element-1461" />
      </main>
      <Footer data-id="element-1462" />
      <CookieBanner data-id="element-1463" />
      <FloatingContact data-id="element-1464" />
    </div>;
}